const tokenClaim =  'http://allegion.com/claims/';

export const config = {
    isFederatedUser: `${tokenClaim}federation`,
    claimUserMetadata: `${tokenClaim}user_metadata`,
    claimUserType: `${tokenClaim}user_type`,
    claimCompanyName: `${tokenClaim}company_name`,
    claimCompanyId: `${tokenClaim}company_id`,
    claimAppMetadataDelete: `${tokenClaim}app_metadata/scheduledForDeletion`,
    idTokenPartsRegex: /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/,
    internalUserClaim: 'internal'
}